import { createAction, props } from '@ngrx/store';
import { ScreenSizeState } from '../models/model';

export const LanguageChangeAction = createAction('Select Language', props<{ selectedLang: string }>());

export const ScreenSizeStateAction = createAction('Size updated', props<ScreenSizeState>());
